import React, { Fragment, useContext } from 'react'
import { Card, Grid, List, ListItem, Message, Button } from 'semantic-ui-react'
import { observer } from 'mobx-react-lite'

const ChangelogList: React.FC = () => {
    return (
        <Fragment>
            <Grid columns={3}>
                <Grid.Column style={{ overflowY: "auto", maxHeight: "90vh", width: "100%" }}>
                <Card.Group>
                    <Card fluid>
                        <Card.Content>
                            <Card.Header>
                                Sprint 10
                            </Card.Header>
                            <Card.Description>
                                <List>
                                    <ListItem>* Issue where the emails 1 hour old and 24 hours old were swapped has been resolved</ListItem>
                                    <ListItem>* Age is now based on the original date created time in the request histories instead of the document date provided by the providers.  This change affects the emailer, request, and request reviews</ListItem>
                                    <ListItem>* Issue where the answer to a question would appear in the text of the question has been resolved</ListItem>
                                    <ListItem>* Foreign on the requests has been named back to Spanish</ListItem>
                                    <ListItem>* If a PDF is missing or something goes wrong bringing back the data, an error pdf will be displayed instead (please let Amanda know if this happens, this issue shouldn’t happen normally)</ListItem>
                                    <ListItem>* Horizontal scroll bar not working when you zoom in issue is now fixed</ListItem>
                                    <ListItem>* Anytime you had to click something on the bottom of the screen and it being blocked is now resolved</ListItem>
                                    <ListItem>* Fixed issue where questions were not being saved but updating the UI to reflect a save.</ListItem>
                                    <ListItem>* This issue caused requests to fail when they should have passed, and they caused the prior review notes not displaying.</ListItem>
                                    <ListItem>* MASSIVE code cleanup on the backend. No functionality should have changed as a result of this but, a full regression testing should be required since virtually every file was affected.</ListItem>
                                    <ListItem>* Fixed issue where the Request list was not updating after a review was completed</ListItem>
                                </List>
                            </Card.Description>
                        </Card.Content>
                    </Card>
                </Card.Group>
                </Grid.Column>
            </Grid>
        </Fragment>
    )
}
export default observer(ChangelogList);